// @ts-nocheck

import React from 'react';

import { __ } from '../../../../i18n/l10n';
import AlertDialog from '../../../../wx/components/alert-dialog';

type ClientUpdaterProps = {
  isOpen: boolean;
  isMandatory: boolean;
  onCancel: () => void;
  onUpdate: () => void;
};
const ClientUpdater = ({ isOpen, isMandatory, onCancel, onUpdate }: ClientUpdaterProps) => {
  const [title, content, buttons] = React.useMemo(() => {
    if (isMandatory) {
      return [
        __('This version of the software is not supported'),
        __('!desc:ClientUpdaterContent'),
        [{ label: __('Open the App Store'), handler: onUpdate, isDefault: true }],
      ];
    }

    return [
      __('This version of the software is not supported'),
      __('!desc:ClientUpdaterContentDeprecated') + ' ' + __('!desc:ClientUpdaterContent'),
      [
        { label: __('Later'), handler: onCancel },
        { label: __('Open the App Store'), handler: onUpdate, isDefault: true },
      ],
    ];
  }, [isMandatory, onCancel, onUpdate]);

  return (
    <AlertDialog
      isOpen={isOpen}
      isCancelable={!isMandatory}
      onCancel={onCancel}
      title={title}
      content={content}
      buttons={buttons}
      isColumn
    />
  );
};

export default ClientUpdater;
